import { useQuery } from "@tanstack/react-query";
import alarmQuestionService from "../../../../services/web/alarm-question-service";

function buildPayload({ page = 1, size = 999999 }) {
    return {
        page,
        size,
        sort: [{ field: "question", dir: "asc" }],
        filter: [],
    };
}

function mapResponse(root) {
    const data = root?.data ?? {};
    const rows = Array.isArray(data?.data) ? data.data : [];

    return {
        rows,
        totalRows: data.last_row ?? rows.length,
        lastPage: data.last_page ?? 1,
    };
}

export function useAlarmQuestionListQuery() {
    return useQuery({
        queryKey: ["alarmQuestions"],
        queryFn: async () => {
            const payload = buildPayload({ page:1, size: 999999 });
            const data = await alarmQuestionService.list(payload);
            return mapResponse(data);
        },
    });
}